import { useEffect, useState, useRef } from "react";
import { AppDispatch, RootState } from "../../redux/store";
import "./Scanner.css";
// Redux
import { useDispatch, useSelector } from "react-redux";
// 不良情報
import { setProcParams, fetchProcs } from "../../redux/defectsSlice";

import RippleButton from "../ui/rippleButton";

// インターフェース
export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BadqueryScanner: React.FC<ModalProps> = (props) => {
  const dispatch: AppDispatch = useDispatch();
  const mediaStream = useRef<MediaStream | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const selectedPlantCode = useSelector(
    (state: RootState) => state.queryParams.selectedPlantCode
  );
  const selectedProcCode = useSelector(
    (state: RootState) => state.queryParams.selectedProcCode
  );
  const machCode = useSelector(
    (state: RootState) => state.queryParams.machCode
  );

  const cameraWidth = 1280; // 画面上のサイズはCSSで指定する（カメラから入力するサイズ）
  const cameraHeight = 720;

  // ビデオデバイスリスト
  const [videoDevices, setVideoDevices] = useState<MediaDeviceInfo[]>([]);
  const [currentVideoDevice, setCurrentVideoDevice] =
    useState<MediaDeviceInfo>();
  const [videoWidth, setVideoWidth] = useState<number>(1280);
  const [videoHeight, setVideoHeight] = useState<number>(720);
  const [currentResolutionId, setCurrentResolutionId] = useState<string>("2");
  // 実際の解像度
  const [dispVideoWidth, setDispVideoWidth] = useState<number>(0);
  const [dispVideoHeight, setDispVideoHeight] = useState<number>(0);

  // カメラのスキャンインターバルタイマー
  let interval: any;
  // カメラの改造度リスト
  const resolutionList = [
    { id: "0", width: 0, height: 0, name: "デフォルト" },
    { id: "1", width: 640, height: 480, name: "480p" },
    { id: "2", width: 1280, height: 720, name: "720p" },
    { id: "3", width: 1920, height: 1080, name: "1080p" },
  ];

  // ビデオデバイスの取得
  useEffect(() => {
    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log("enumerateDevices() not supported.");
    } else {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          const workVideoDevices = devices.filter(
            (d) => d.kind === "videoinput"
          );
          setVideoDevices(workVideoDevices);
          if (workVideoDevices.length > 0) {
            setCurrentVideoDevice(workVideoDevices[0]);
          }
          devices.forEach((device) => {
            console.log(
              `${device.kind}: ${device.label} id = ${device.deviceId}`
            );
          });
        })
        .catch((err) => {
          console.error(`${err.name}: ${err.message}`);
        });
    }

    return () => {
      // タイマーをクリア
      clearInterval(interval);
      // カメラストップ
      mediaStream.current?.getTracks().forEach((track) => track.stop());
      mediaStream.current = null;
    };
  }, []);

  // 読取完了ボタン押下時の処理
  const closeDisp = () => {
    props.onClose(); // Defectsの閉じる機能を呼び出す。
  };

  const scanVideoFrame = async () => {
    try {
      const video = videoRef.current;
      if (!video || video.readyState < video.HAVE_ENOUGH_DATA) return;
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      if (!ctx) return;
      ctx.clearRect(0, 0, cameraWidth, cameraHeight);
      ctx.drawImage(video, 0, 0, cameraWidth, cameraHeight);
      const imgData = ctx.getImageData(0, 0, cameraWidth, cameraHeight);
      const res: Promise<any[]> = await window.zbarWasm.scanImageData(
        imgData as unknown as ImageData
      );
      const decodedTexts = (await res).map((result) => {
        const decoded = result.decode();
        // Log each decoded result
        //console.log("Decoded Text:", decoded);

        if (decoded) {
          return decoded.toString();
        }
        return "Decoding failed";
      });
      if (decodedTexts.length > 0) {
        console.log(selectedPlantCode);
        console.log(selectedProcCode);
        console.log(machCode);
        const selectMachcode = machCode.length === 1 ? machCode[0] : "";
        dispatch(
          setProcParams({
            plantCode: selectedPlantCode,
            procCode: selectedProcCode,
            machCode: selectMachcode,
            poDescNum: decodedTexts[0].toString(),
          })
        );
        //console.log("Decoded Text:", decodedTexts[0]);
        // 不良情報取得
        dispatch(
          fetchProcs({
            plantCode: selectedPlantCode,
            procCode: selectedProcCode,
            machCode: selectMachcode,
            poDescNum: decodedTexts[0].toString(),
          })
        );
        props.onClose();
        // タイマーをクリア
        clearInterval(interval);
        // カメラストップ
        mediaStream.current?.getTracks().forEach((track) => track.stop());
        mediaStream.current = null;
        return decodedTexts[0].toString();
      }
    } catch (error) {
      console.error("Error scanning video frame:", error);
    }
  };

  useEffect(() => {
    const constraints =
      currentResolutionId === "0"
        ? {
            video: {
              deviceId: currentVideoDevice?.deviceId,
            },
          }
        : {
            video: {
              //facingMode: 'user',
              deviceId: currentVideoDevice?.deviceId,
              width: { ideal: videoWidth },
              height: { ideal: videoHeight },
            },
          };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        mediaStream.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
        const track = stream.getVideoTracks()[0];
        const settings = track.getSettings();
        if (
          settings !== undefined &&
          settings.width !== undefined &&
          settings.height !== undefined
        ) {
          setDispVideoWidth(settings.width);
          setDispVideoHeight(settings.height);
        }
      })
      .catch((err) => {
        console.error("An error occurred: " + err);
        alert(
          "An error occurred while trying to get the camera: " + err.message
        );
      });
    clearInterval(interval);
    // 定期的に画像を抽出するためのタイマー処理
    interval = setInterval(scanVideoFrame, 100);
  }, [currentVideoDevice, currentResolutionId]);

  // ビデオデバイス変更
  const handleDeviceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(e.target.value);
    const selectDevice = videoDevices.filter(
      (d) => d.deviceId == e.target.value
    );
    setCurrentVideoDevice(selectDevice[0]);
  };

  // ビデオ解像度変更
  const handleResolutionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(e.target.value);
    const resolution = resolutionList.filter((d) => d.id === e.target.value);
    setVideoWidth(resolution[0].width);
    setVideoHeight(resolution[0].height);
    setCurrentResolutionId(resolution[0].id);
  };

  return (
    <div className="badquery-scanner-container">
      <div className="scanner-title-item">
        <p className="full-text text-center">Scanning...</p>
        <p className="normal-textCol text-center">スキャン中</p>
      </div>

      <div className="scanner-devicelist-item">
        <label htmlFor="scanner-devicelist-id">デバイス</label>
        <select
          id="scanner-devicelist-id"
          onChange={handleDeviceChange}
          value={currentVideoDevice?.deviceId}
          className=""
        >
          {videoDevices?.map(({ deviceId, label }) => (
            <option key={deviceId} value={deviceId}>{`${label}`}</option>
          ))}
        </select>

        <label htmlFor="scanner-resolution-id">解像度 </label>
        <select
          id="scanner-resolution-id"
          onChange={handleResolutionChange}
          value={currentResolutionId}
          className=""
        >
          {resolutionList?.map(({ id, name }) => (
            <option key={id} value={id}>{`${name}`}</option>
          ))}
        </select>
      </div>

      <div className="scanner-viewport-item">
        <div className="view-resolution">
          width:{dispVideoWidth} height:{dispVideoHeight}
        </div>
        <canvas
          id="canvas"
          ref={canvasRef}
          className="badquery-scanner-video"
          width={cameraWidth}
          height={cameraHeight}
        />
        <video
          id="video"
          ref={videoRef}
          autoPlay={true}
          className="badquery-scanner-video"
          width={cameraWidth}
          height={cameraHeight}
        />
      </div>

      <div className="scanner-button-item">
        <div className="btn">
          <RippleButton
            width={"640px"}
            heihgt={"56px"}
            borderRadius={"8px"}
            onClick={closeDisp}
            effectSize={160}
            className="bk-secondary"
          >
            <span className="children">終了</span>
          </RippleButton>
        </div>
      </div>
    </div>
  );
};

export default BadqueryScanner;
